module.exports = __webpack_public_path__ + "img/battery-charging.1cd7a41a.svg";